// extracted by mini-css-extract-plugin
export var hideEditor = "_ly-2";
export var infoIcon = "_ly-3";
export var label = "_ly-1";
export var labelContainer = "_ly-0";
export var readonlyText = "_ly-4";